export default __webpack_public_path__ + "static/media/password_key.aed37d2b.svg";